/**
 * Capacitor specific concern coordination
 */
export default async (app) => {
  if (!window.Capacitor?.isNative) {
    return
  }

  // iOS presenter apps do not allow signup
  const isIos = window.Capacitor?.platform === 'ios'
  const presenterRole = app.options.role === 'presenter'

  app.options.allowSignups = !(isIos && presenterRole)

  // Cordova apps cannot use pushstate
  app.options.pushState = false

  // Cordova apps cannot redirect the container to other sites
  app.options.allowRedirects = false

  // Force debug mode when in capacitor debug environment
  app.options.debug = window.Capacitor?.DEBUG

  // Dyanmically load the chunks
  const {
    ExternalScreenDispatcher,
    StatusBarDispatcher,
    FirebaseDispatcher,
    DeepLinking,
    SplashScreen,
    Rollbar,
    InAppPurchase
  } = await import(/* webpackChunkName: 'capacitor-dispatchers-chunk' */ './chunk')

  ExternalScreenDispatcher(app)
  StatusBarDispatcher(app)
  FirebaseDispatcher(app)
  DeepLinking(app)
  SplashScreen(app)
  Rollbar(app)
  InAppPurchase(app)

  // Handle Android back button
  window.Capacitor.Plugins.App.addListener('backButton', () => {
    window.history.back()
  }, false)
}
